// extracted by mini-css-extract-plugin
export var content = "PartnerFinalCtaSection-module__content___NIUlM";
export var description = "PartnerFinalCtaSection-module__description___2mjPj";
export var game1 = "PartnerFinalCtaSection-module__game1___fh-D1";
export var game2 = "PartnerFinalCtaSection-module__game2___myCax";
export var game3 = "PartnerFinalCtaSection-module__game3___dWp6z";
export var game4 = "PartnerFinalCtaSection-module__game4___eOUUZ";
export var gameIcon = "PartnerFinalCtaSection-module__gameIcon___-nZ-y";
export var gameIconFloat = "PartnerFinalCtaSection-module__gameIconFloat___2b-b6";
export var getStartedButton = "PartnerFinalCtaSection-module__getStartedButton___3qm6c";
export var section = "PartnerFinalCtaSection-module__section___kKJxo";
export var title = "PartnerFinalCtaSection-module__title___rSMLz";